import React, { useEffect } from 'react';
import { Col, Row } from "react-bootstrap";
import { Dispatch, bindActionCreators, AnyAction } from 'redux';
import { connect } from 'react-redux';
import { AppState } from '../store/configureStore';
import { errorHandlingActionCreators } from '../store/ErrorHandling';

export interface OwnProps { message?: string }
type TErrorHandlingProps = ReturnType<typeof mapStateToProps> & ReturnType<typeof mapDispatchToProps>;

const ErrorHandling = (props: TErrorHandlingProps) => {
    const { message,
        logError
    } = props;

    useEffect(() => {
        console.log(message);
        logError(message);
    })

    return (
        <Row className="justify-content-center">
            <Col className="col-12 col-md-6 col-lg-5 col-xl-5">
            <Row className ="errorCard">
                    <Col className="errorCardTitle">
                        Error
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <p>
                            An unexpected error has occured.
                        </p>

                        <p className="text-muted small">
                            Code: c1
                        </p>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
}
function mapStateToProps(state: AppState, ownProps: OwnProps) {
    return {
        ...ownProps
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return bindActionCreators({
        ...errorHandlingActionCreators
    }, dispatch);
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ErrorHandling);


